import { name as packageNameScoped } from '../../../../package.json';

const packageName = packageNameScoped.substring(packageNameScoped.indexOf('/')+1);
// let focused = false;

// function debounce(func, timeout = 500){
//   let timer;
//   return (...args) => {
//     clearTimeout(timer);
//     timer = setTimeout(() => { func.apply(this, args); }, timeout);
//   };
// }

const debouncedFocus = (event) => {
  // if (focused) {
  //   return false;
  // }

  const autofocus = document.querySelector('[autofocus]');

  if (window.stzhComponents.fixAutofocus
      && !document.location.hash
      && autofocus
      && event.detail.namespace === packageName
      && autofocus.tagName.toLowerCase().indexOf('stzh-') === 0
      && 'focus' in autofocus
  ) {
    autofocus.focus();
    // focused = true;
  } else if (window.stzhComponents.fixHashfocus && document.location.hash) {
    const hashElement = document.querySelector(document.location.hash);

    if (hashElement) {
      hashElement.scrollIntoView();
      // focused = true;
    }
  }
}

/**
 * Execute setFocus method if it exists
 * on stzh-element with autofocus on pageload
 * when (child components are loaded)
 */
export function applyAutofocus() {
  window.addEventListener('appload', debouncedFocus);
}
